export const acnPattern = /^\d{9}$/;
